var map = {
	"./AnnouncementsWidget.vue": 44870,
	"./ResourcesWidget.vue": 6128,
	"./StatsWidget.vue": 92228,
	"./TemplateSelectWidget.vue": 76389,
	"./TopCampaignsWidget.vue": 99636,
	"./UpsellBox.vue": 88454,
	"./UpsellWidget.vue": 68901
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51327;